// Use ad a base flex component and add up needed properties
//
// const component = styled(FlexDiv)`
// justify-content: space-between;
// `
import styled from "styled-components"
import type {
  width,
  align,
  justify,
  content,
  PaddingType,
} from "../../styles/theme"

export const FlexDiv = styled.div<{
  padding?: string
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: inherit;
  padding: ${(props) => props.padding || "0px"};
  box-sizing: border-box;
`

export const FlexDivRow = styled(FlexDiv)<{ gap?: string }>`
  flex-direction: row;
  gap: ${(props) => props.gap || "8px"};
`

export const FullWidthFlexRow = styled(FlexDivRow)`
  width: 100%;
  flex-wrap: wrap;
`

// New components
interface BoxProps {
  width?: keyof typeof width
  height?: keyof typeof width | string
  widthFixed?: string
  padding?: PaddingType
  paddingY?: PaddingType
  paddingX?: PaddingType
  position?: string
  flex?: number | string
  shrink?: string
  grow?: number
  overflow?: string
  bgColor?: string
  top?: string
}

interface ContainerProps extends BoxProps {
  gap?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9
  justify?: keyof typeof justify
  align?: keyof typeof align
  alignSelf?: keyof typeof align
  content?: keyof typeof content
  /** Whether the container should be displayed as flex */
  noflex?: boolean
  wrap?: boolean
}

export const Box = styled.div<BoxProps>`
  width: ${({ width, widthFixed, theme }) =>
    widthFixed ? widthFixed : theme.width[width || "full"]};
  height: ${({ height, theme }) =>
    height ? theme.width[height] || height : theme.width["auto"]};
  padding: ${({ padding, theme }) => `${theme.spacing[padding || 0]}`};
  ${({ paddingX, theme }) =>
    paddingX &&
    `padding-right: ${theme.spacing[paddingX || 1]};
    padding-left: ${theme.spacing[paddingX || 1]};`}
  ${({ paddingY, theme }) =>
    paddingY &&
    `padding-top: ${theme.spacing[paddingY || 1]};
    padding-bottom: ${theme.spacing[paddingY || 1]};`}
  box-sizing: border-box;
  position: ${({ position }) => (position ? position : "relative")};
  ${({ flex }) => flex && `flex: ${flex};`}
  ${({ shrink }) => shrink && `flex-shrink: ${shrink};`}
  ${({ grow }) => grow && `flex-grow: ${grow};`}
  ${({ overflow }) => overflow && `overflow: ${overflow};`}
  ${({ bgColor, theme }) => bgColor && `background-color: ${theme[bgColor]};`}
  ${({ top }) => top && `top: ${top};`}
`

export const Container = styled(Box)<ContainerProps>`
  ${({ noflex }) => (noflex ? "" : "display: flex;")}
  gap: ${({ gap, theme }) => `${theme.spacing[gap || 0]}`};
  justify-content: ${({ justify, theme }) =>
    `${theme.justify[justify || "start"]}`};
  align-items: ${({ align, theme }) => `${theme.align[align || "start"]}`};
  align-self: ${({ alignSelf, theme }) =>
    `${theme.align[alignSelf || "initial"]}`};
  align-content: ${({ content, theme }) =>
    `${theme.justify[content || "start"]}`};
  ${({ wrap }) => wrap && `flex-wrap: wrap;`}
`
// RowsContainer
export const RowsContainer = styled(Container)<ContainerProps>`
  flex-direction: column;
`
// ColumnsContainer
export const ColumnsContainer = styled(Container)<ContainerProps>`
  flex-direction: row;
`
